export default "__VITE_ASSET__M6$$5cPh__"